import { times, minus, plus } from 'number-precision'
import { KENO_PAYOUTS, KENO_RISK_MODES } from './keno.constants'
import { BET_RESULT } from 'constants/index'
// import { KENO_PAYOUTS, BET_RESULT, DEFAULT_GAME_ID, TRANSACTION_STATUS, WALLET_EMIT_TYPES, KENO_CONSTANTS, GAMES, OPERATOR_CALLBACK_ERROR_CODES_TO_TYPES, KENO_RISK_MODES } from '../../../libs/constants'
import { v4 as uuid } from 'uuid'

const kenoGameGenerateResult = () => {
  const numsRequired = KENO_CONSTANTS.NUMBER_REQUIRED_FOR_KENO
  const pool = Array.from({ length: KENO_CONSTANTS.MAX_KENO_NUMBER }, (_, i) => i + 1) // Creating a object pool of 80 numbers

  for (let currentNum = 0; currentNum < numsRequired; currentNum++) {
    const randomNumber = Math.random() // uniformly distributed in [0; 1)
    const randomGeneratedBall = currentNum + parseInt(randomNumber * (pool.length - currentNum))

    if (randomGeneratedBall !== currentNum) {
      [pool[currentNum], pool[randomGeneratedBall]] = [pool[randomGeneratedBall], pool[currentNum]]
    }
  }
  return numsRequired ? pool.slice(0, numsRequired) : pool
}

const DEMO_KENO_GAME_SETTINGS = {
  id: '5',
  gameId: 5,
  minBet: {
    USD: 0.5,
    FUN: 0.5
  },
  maxBet: {
    USD: 20,
    FUN: 20
  },
  maxProfit: {
    USD: 1000,
    FUN: 1000
  },
  houseEdge: 1,
  minOdd: 1,
  maxOdd: 10000,
  minAutoRate: 1.01
}

const KENO_CONSTANTS = {
  NUMBER_REQUIRED_FOR_KENO: 10,
  MIN_KENO_NUMBER: 1,
  MAX_KENO_NUMBER: 40,
  MIN_KENO_SELECTEDBALLS: 1,
  MAX_KENO_SELECTEDBALLS: 10
}

export const kenoGameDemoPlaceBetService = function ({ selectedBalls, betAmount, riskMode }) {
  if (selectedBalls.length < KENO_CONSTANTS.MIN_KENO_SELECTEDBALLS || selectedBalls.length > KENO_CONSTANTS.MAX_KENO_SELECTEDBALLS) {
    throw new Error('SelectedBallsErrorType')
  }

  if (new Set(selectedBalls).size !== selectedBalls.length) throw new Error('DuplicateSelectedBallsErrorType')

  for (const ball of selectedBalls) {
    if (ball < KENO_CONSTANTS.MIN_KENO_NUMBER || ball > KENO_CONSTANTS.MAX_KENO_NUMBER) {
      throw new Error('SelectedBallsRangeErrorType')
    }
  }

  if (!(Object.values(KENO_RISK_MODES)?.includes(riskMode))) {
    throw new Error('InvalidRiskModeErrorType')
  }

  const matchedBalls = []

  const { minBet, maxBet, maxProfit } = DEMO_KENO_GAME_SETTINGS

  if (betAmount < +minBet.amount || betAmount > +maxBet.amount) {
    throw new Error('BetAmountIsNotInLimitErrorType', `beAmount ${betAmount}`)
  }

  const randomSelectedBalls = kenoGameGenerateResult()

  for (const ball of randomSelectedBalls) {
    if (selectedBalls.includes(ball)) matchedBalls.push(ball)
  }

  let betResult = BET_RESULT.LOST
  let winningAmount = 0

  const odds = KENO_PAYOUTS?.[selectedBalls.length]?.[riskMode]?.[matchedBalls.length]

  betResult = odds > 0 ? BET_RESULT.WON : BET_RESULT.LOST
  winningAmount = times(odds, betAmount)
  const profit = minus(winningAmount, betAmount)

  if (profit > +maxProfit.amount) {
    winningAmount = plus(betAmount, maxProfit.amount)
  }

  const kenoGameBet = {
    id: uuid(),
    betAmount,
    winningAmount,
    result: betResult,
    riskMode,
    totalHits: matchedBalls.length,
    userNumbers: selectedBalls,
    randomSelectedBalls
  }

  return { ...kenoGameBet }
}
